/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
export var InputGroupDisplayType = /*@__PURE__*/ (function (InputGroupDisplayType) {
    InputGroupDisplayType[InputGroupDisplayType["Line"] = 0] = "Line";
    InputGroupDisplayType[InputGroupDisplayType["Box"] = 1] = "Box";
    InputGroupDisplayType[InputGroupDisplayType["Border"] = 2] = "Border";
    InputGroupDisplayType[InputGroupDisplayType["Search"] = 3] = "Search";
    return InputGroupDisplayType;
})({});
/**
 * @hidden
 */
export var InputGroupDisplayType_$type = /*@__PURE__*/ markEnum('InputGroupDisplayType', 'Line,0|Box,1|Border,2|Search,3');
//# sourceMappingURL=InputGroupDisplayType.js.map
